/* eslint-disable jsx-a11y/anchor-is-valid */
import { Dropdown, Space } from "antd";
import cx from "classnames";
import i18n from "i18n";
import { Fragment, useCallback, useEffect, useMemo, useState } from "react";

import { DownOutlined } from "@ant-design/icons";
import EN from "./EN.json";
import TH from "./TH.json";
import ZH from "./ZH.json";
import dayjs from "dayjs";

import styles from "./LanguageSwitcher.module.css";

const LANGUAGE_OPTIONS = [
  { flag: "data:image/png;base64, " + EN, label: "ENGLISH", value: "en" },
  { flag: "data:image/png;base64, " + TH, label: "ภาษาไทย", value: "th" },
  { flag: "data:image/png;base64, " + ZH, label: "中文", value: "zh" },
];

function LanguageSwitcher({ className = "", showDropdown = true, absolute = false, hideText = false }) {
  const [initialized, setInitialized] = useState(false);

  const [language, setLanguage] = useState("en");

  const handleChange = useCallback((lng) => {
    setLanguage(lng);
    window.localStorage.setItem("lang", lng);
    i18n.changeLanguage(lng);
    dayjs.locale(lng);
  }, [setLanguage]);

  const selectedLanguage = useMemo(() => {
    return (
      LANGUAGE_OPTIONS.find((opt) => opt.value === window?.localStorage?.getItem("lang")) ||
      LANGUAGE_OPTIONS[0]
    );
  }, [window?.localStorage?.getItem("lang")]);

  useEffect(() => {
    const defaultLng = window.localStorage.getItem("lang") || "en";
    setLanguage(defaultLng);
    setInitialized(true);
  }, []);

  const renderPage = useCallback(
    () => {
      const nextLanguage = language === "en" ? "th" : "en";
      return (
        <img
          src={selectedLanguage.flag}
          className={styles.flag}
          alt={language}
          aria-label={language}
          width={40}
          height={25}
          onClick={() => handleChange(nextLanguage)}
          style={{ borderRadius: "3px", cursor: "pointer" }}
        />
      )
    },
    [selectedLanguage, language],
  )

  if (!initialized) return null;

  if (showDropdown) {
    return (
      <Dropdown
        className={cx(styles.customStyle, { [styles.absolute]: absolute },)}
        defaultValue={language}
        menu={{
          items: LANGUAGE_OPTIONS.map((opt) => ({
            key: opt.value,
            label: (
              <Space onClick={() => handleChange(opt.value)}>
                <img
                  src={opt.flag}
                  alt={opt.value}
                  aria-label={opt.value}
                  width={40}
                  height="auto"
                />
                {opt.label}
              </Space>
            ),
          })),
        }}
        size="large"
        value={language}
      >
        <Space>
          <img
            src={selectedLanguage.flag}
            className={styles.flag}
            alt={language}
            aria-label={language}
            width={40}
            height="auto"
            style={{ borderRadius: "3px", cursor: "pointer" }}
          />
          {!hideText && <>
            <span style={{ color: "#00275A" }}>{selectedLanguage.label}</span>
            <DownOutlined style={{ color: "#00275A" }} />
          </>}
        </Space>
      </Dropdown>
    );
  }


  return (
    renderPage()
  );

}

export default LanguageSwitcher;
